import React, { useEffect, useState } from "react";
import Avatar from "react-avatar";
import { Grid, List, Star } from "react-feather";
import Rating from "react-rating";

import Select from "react-select";
import Pagination from "react-bootstrap/Pagination";
import { useGlobalContext } from "../../context";
import { useParams } from "react-router-dom";

import AsyncSelect from "react-select/async";
import { Link } from "react-router-dom";

const PopularAuthorsBooks = () => {
  const { isNightMode } = useGlobalContext();
  const [selectedOption, setSelectedOption] = useState("Data Descending");

  const [searchTerm, setSearchTerm] = useState(
    localStorage.getItem("searchTerm") || ""
  );
  const [publisher, setPublisher] = useState("");
  const [selectedAuthor, setSelectedAuthor] = useState("");
  const [selectedYear, setSelectedYear] = useState(
    localStorage.getItem("filterYear") || ""
  );
  const [selectedGenre, setSelectedGenre] = useState(
    localStorage.getItem("filterDenre") || ""
  );
  const [selectedLevel, setSelectedLevel] = useState(
    localStorage.getItem("filterLevel") || ""
  );
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [selectedRating, setSelectedRating] = useState(
    localStorage.getItem("filterRating") || ""
  );

  const [currentPage, setCurrentPage] = useState(1);
  // const total = 100; // Replace with your total number of pages
  const maxPagesToShow = 7; // Maximum number of pages to show in the pagination UI

  const [perPage, setPerPage] = useState(10);

  const [isGrid, setIsGrid] = useState(true);
  const [loading, setLoading] = useState(true);
  const [mmBooks, setMmBooks] = useState([]);
  const [foundresults, setFoundresults] = useState();

  const [allAuthors, setAllAuthors] = useState([]);
  const [allCategories, setAllCategories] = useState([]);

  const { id } = useParams();
  const [clear, setClear] = useState(false);

  const actualTotal = Math.ceil(foundresults / perPage); // Calculate actual total number of pages
  const total = Math.min(actualTotal, 100);

  const [selectedTitleOption, setSelectedTitleOption] = useState(null);

  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      fetch(
        `https://api.elibrary.suoe.edu.mm/authors/${id}/names?title=${inputValue}`
      )
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          const options = data.authorBookNames?.map((book) => ({
            label: book.title,
            value: book.title,
            id: book._id,
            photo: book.coverPhoto,
            author: book.author,
            rating: book.rate,
          }));
          resolve(options);
        });
    });

  useEffect(() => {
    fetch(`https://api.elibrary.suoe.edu.mm/authors?all=true`)
      .then((response) => response.json())
      .then((res) => {
        console.log(res);
        setAllAuthors(res?.authors);
        // setLoading(false)
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    fetch(`https://api.elibrary.suoe.edu.mm/books/categories`)
      .then((response) => response.json())
      .then((res) => {
        console.log(res);
        setAllCategories(res?.categories);
        // setLoading(false)
      })
      .catch((error) => console.error(error));
  }, []);

  // const data = [
  //     {
  //         "_id": "62e1e599279b22a6d3d87d26",
  //         "title": "PC Hardware A Beginner's Guide",
  //         "dataId": 18831195,
  //         "pageCount": "673",
  //         "publishAdt": 2009,
  //         "fileSize": "14.17 MB",
  //         "downloadCount": "59,166 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/045/04573a7c6a7567a8170299e13f38f869-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Hardware"
  //         ],
  //         "author": "",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=18831195&h=0679cc85bd14edb0fe7315f9ed021da1&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d29",
  //         "title": "The 8051 Microcontroller and Embedded",
  //         "dataId": 952238,
  //         "pageCount": "617",
  //         "publishAdt": 2008,
  //         "fileSize": "4.2 MB",
  //         "downloadCount": "82,545 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/437/43779a398d95161e516066a3d0edb206-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Programming",
  //             "Technology"
  //         ],
  //         "author": "",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=952238&h=5d72b944edad8a70dbbdd7d90646a7c8&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d2a",
  //         "title": "Python and Tkinter Programming",
  //         "dataId": 33413070,
  //         "pageCount": "684",
  //         "publishAdt": 2005,
  //         "fileSize": "8.97 MB",
  //         "downloadCount": "59,700 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/f1c/f1c086912b8000000b326459a73aad6b-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Programming"
  //         ],
  //         "author": "John E. Grayson",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=33413070&h=e2d3fc1b775e640d0d3168c7927e3fa0&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d2b",
  //         "title": "Beginning Java Programming For Dummies",
  //         "dataId": 33408771,
  //         "pageCount": "408",
  //         "publishAdt": 2005,
  //         "fileSize": "5.87 MB",
  //         "downloadCount": "33,515 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/8f5/8f5a539f83a88fd40f95b0d148d2bb83-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Programming"
  //         ],
  //         "author": "",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=33408771&h=e5a76bc596fb31537c60f026cd3cb158&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d2c",
  //         "title": "Pro HTML5 and CSS3 Design Patterns",
  //         "dataId": 12105664,
  //         "pageCount": "514",
  //         "publishAdt": 2011,
  //         "fileSize": "11.68 MB",
  //         "downloadCount": "84,501 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/90a/90a131f9da39985cfa1cbbee463d91a5-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Technology",
  //             "Software"
  //         ],
  //         "author": "",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=12105664&h=34e5f297b998de5f3cc63cbebda16314&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d2d",
  //         "title": "Automobile Engineering",
  //         "dataId": 39671340,
  //         "pageCount": "247",
  //         "publishAdt": 2012,
  //         "fileSize": "1.43 MB",
  //         "downloadCount": "39,100 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/b75/b75418159a6223353f60d0f283ffb52f-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Automotive"
  //         ],
  //         "author": "",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=39671340&h=1b56cdf3833a0f435b42c7da71156409&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d27",
  //         "title": "Cracking the Coding Interview, Fourth Edition: 150 Programming ",
  //         "dataId": 685299,
  //         "pageCount": "310",
  //         "publishAdt": 2010,
  //         "fileSize": "2.05 MB",
  //         "downloadCount": "94,741 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/955/95567fe62c3159d5ac99e2fbdecce7d9-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Programming"
  //         ],
  //         "author": "Gayle Laakmann",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=685299&h=2cec5f957c50f17bdd1d162e7ee95379&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d28",
  //         "title": "Internet of Things",
  //         "dataId": 17335820,
  //         "pageCount": "144",
  //         "publishAdt": 2015,
  //         "fileSize": "3.28 MB",
  //         "downloadCount": "50,872 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/51f/51f81ad1f15c986d9665cddaa084ebbc-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Internet"
  //         ],
  //         "author": "",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=17335820&h=1dad8a7ae8057dfd84b0c333d66a6778&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d32",
  //         "title": "Data Structures with Java",
  //         "dataId": 19408917,
  //         "pageCount": "351",
  //         "publishAdt": 2007,
  //         "fileSize": "7.23 MB",
  //         "downloadCount": "54,530 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/17a/17adb14fedc8492d233286267545b7bd-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Programming",
  //             "Editor's Picks",
  //             "Most Popular"
  //         ],
  //         "author": "",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=19408917&h=d79aa7bc7cd3f23b3d71f92ee810ccc9&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d31",
  //         "title": "Foundations of Python Network Programming",
  //         "dataId": 22768963,
  //         "pageCount": "369",
  //         "publishAdt": 2014,
  //         "fileSize": "3.71 MB",
  //         "downloadCount": "58,109 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/ef9/ef9268f9fca2a6fbdcf402f6ab92cdc6-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Programming"
  //         ],
  //         "author": "",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=22768963&h=7997ecc5518892540d06d75f4efb93ad&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d30",
  //         "title": "Learn Java for Web Development",
  //         "dataId": 25178589,
  //         "pageCount": "461",
  //         "publishAdt": 2014,
  //         "fileSize": "16.88 MB",
  //         "downloadCount": "56,784 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/d44/d445bd0a4ebb52943adde5f11735feea-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Web Design"
  //         ],
  //         "author": "",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=25178589&h=2399df2930020fa747e0c8d17bfc8720&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d33",
  //         "title": "Signals and Systems - Electrical Engineering",
  //         "dataId": 17936001,
  //         "pageCount": "769",
  //         "publishAdt": 2012,
  //         "fileSize": "6.34 MB",
  //         "downloadCount": "40,823 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/90a/90ad2eacb328506d206a73111238c69b-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Engineering",
  //             "Tutorials"
  //         ],
  //         "author": "",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=17936001&h=6f2b538c98e0786e26bd24b6bf8563f9&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d35",
  //         "title": "Data Communication and Computer Network",
  //         "dataId": 18727785,
  //         "pageCount": "106",
  //         "publishAdt": 2014,
  //         "fileSize": "2.56 MB",
  //         "downloadCount": "35,816 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/48a/48aaf84b6bdeed6edcb9a2e20352add4-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Technology"
  //         ],
  //         "author": "Manisha Shejwal",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=18727785&h=ebfda293f1c8ff27ce7a443029e5fd0f&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d34",
  //         "title": "IT Essentials: PC Hardware and Software Companion Guide",
  //         "dataId": 3034642,
  //         "pageCount": "108",
  //         "publishAdt": 2013,
  //         "fileSize": "1.36 MB",
  //         "downloadCount": "40,267 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/6da/6da82427cc34686c663473df37c9417d-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Hardware",
  //             "Software"
  //         ],
  //         "author": "Cisco Networking Academy",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=3034642&h=629b02f6935ff1c066cc1eda568950cb&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d36",
  //         "title": "Mathematical Foundation of Computer Science",
  //         "dataId": 18828981,
  //         "pageCount": "393",
  //         "publishAdt": 2007,
  //         "fileSize": "2.58 MB",
  //         "downloadCount": "41,214 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/551/551bd7ab438fc15d0b1daa09b5e9f1d1-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Technology"
  //         ],
  //         "author": "",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=18828981&h=289ccca248c698fd4927d72adaf1dfce&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d37",
  //         "title": "Microsoft Access VBA Macro Programming",
  //         "dataId": 1108997,
  //         "pageCount": "400",
  //         "publishAdt": 2010,
  //         "fileSize": "4.37 MB",
  //         "downloadCount": "59,229 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/88b/88bd1446cc1c2a90c2fbe1f8e8d46b71-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Programming"
  //         ],
  //         "author": "",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=1108997&h=9d6df38ad5154ff15385cfaaf44971d3&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d38",
  //         "title": "Modeling Structured Finance Cash Flows with Microsoft Excel",
  //         "dataId": 6423094,
  //         "pageCount": "221",
  //         "publishAdt": 2007,
  //         "fileSize": "6.62 MB",
  //         "downloadCount": "58,318 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/9c3/9c342e1cb23734b9e76ddaa81d993f1a-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Academic & Education",
  //             "Finance",
  //             "Software"
  //         ],
  //         "author": "",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=6423094&h=9ae4de6171458d8248ef09f0ebc2e171&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d39",
  //         "title": "Photoshop for Dummies",
  //         "dataId": 7451134,
  //         "pageCount": "778",
  //         "publishAdt": 2010,
  //         "fileSize": "35.44 MB",
  //         "downloadCount": "109,774 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/6b4/6b455692c155a2d495af5c815c1232d6-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Art",
  //             "Technology"
  //         ],
  //         "author": "",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=7451134&h=ed4bbecd358e0277a43d6640e5424080&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d2f",
  //         "title": "Reverse Engineering",
  //         "dataId": 18717877,
  //         "pageCount": "620",
  //         "publishAdt": 2005,
  //         "fileSize": "8.54 MB",
  //         "downloadCount": "32,448 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/be4/be446260e2ea7690b6982d5ad490d74b-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Engineering",
  //             "Software"
  //         ],
  //         "author": "Eilam, Eldad.",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=18717877&h=a7565034ddcd228e04d8f873eac36802&u=cache&ext=pdf",
  //         "__v": 0
  //     },
  //     {
  //         "_id": "62e1e599279b22a6d3d87d2e",
  //         "title": "WordPress Web Design For Dummies",
  //         "dataId": 24529047,
  //         "pageCount": "387",
  //         "publishAdt": 2013,
  //         "fileSize": "34.48 MB",
  //         "downloadCount": "65,087 Downloads",
  //         "coverImage": "https://cdn.asaha.com/assets/thumbs/498/498549f0cb16afc0a15e4388cafa14f6-s.jpg",
  //         "category": "Technology",
  //         "tags": [
  //             "Web Design"
  //         ],
  //         "author": "",
  //         "link": "https://www.pdfdrive.com/download.pdf?id=24529047&h=2fc20f2912a75211151c9f491b868ba1&u=cache&ext=pdf",
  //         "__v": 0
  //     }
  // ]

  useEffect(() => {
    setLoading(true);
    fetch(
      `https://api.elibrary.suoe.edu.mm/authors/${id}?page=${
        currentPage - 1
      }&bookPerPage=${perPage}&title=${searchTerm}&author=${selectedAuthor}&rating=${selectedRating}&year=${selectedYear}&level=${selectedLevel}&category=${selectedGenre}&sort=${selectedOption}`
    )
      // fetch(`https://api.elibrary.suoe.edu.mm/books`)
      .then((response) => response.json())
      .then((res) => {
        console.log("popularbooks", res);
        setMmBooks(res?.books);
        setFoundresults(res?.total_results);
        setLoading(false);
      })
      .catch((error) => console.error(error));
  }, [perPage, currentPage, clear, selectedOption]);

  const filtersApi = () => {
    setLoading(true);
    fetch(
      `https://api.elibrary.suoe.edu.mm/authors/${id}?page=${
        currentPage - 1
      }&bookPerPage=${perPage}&title=${searchTerm}&author=${selectedAuthor}&rating=${selectedRating}&year=${selectedYear}&level=${selectedLevel}&category=${selectedGenre}&sort=${selectedOption}`
    )
      // fetch(`https://api.elibrary.suoe.edu.mm/books`)
      .then((response) => response.json())
      .then((res) => {
        console.log(res);
        setMmBooks(res?.books);
        setFoundresults(res?.total_results);
        setLoading(false);
      })
      .catch((error) => console.error(error));
  };

  console.log(isGrid);

  const handlePerPageChange = (selectedOption) => {
    setPerPage(selectedOption.value);
    setCurrentPage(1);
    // Do something with the selected number of items per page
  };

  // const goToDetial = () => {
  //     localStorage.setItem('currentScrollPos', window.scrollY);
  // }
  // useEffect(() => {
  //     const timeout = setTimeout(() => {
  //         const currentScrollPos = localStorage.getItem('currentScrollPos');
  //         if (currentScrollPos) {
  //             window.scrollTo(0, parseInt(currentScrollPos));
  //         }
  //     }, 100);
  //     return () => clearTimeout(timeout);
  // }, [])

  const options = [
    { value: 10, label: "10 per page" },
    { value: 20, label: "20 per page" },
    { value: 50, label: "50 per page" },
    { value: 100, label: "100 per page" },
  ];

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
    console.log(pageNumber);
    // Do something with the selected page number
  };

  const renderPageItem = (pageNumber) => (
    <Pagination.Item
      key={pageNumber}
      active={pageNumber === currentPage}
      onClick={() => handlePageClick(pageNumber)}
    >
      {pageNumber}
    </Pagination.Item>
  );

  const renderEllipsisItem = () => (
    <Pagination.Ellipsis key="ellipsis" disabled />
  );

  const paginationItems = [];
  if (total <= maxPagesToShow) {
    for (let i = 1; i <= total; i++) {
      paginationItems.push(renderPageItem(i));
    }
  } else {
    const leftPagesToShow = Math.ceil(maxPagesToShow / 2) - 1;
    const rightPagesToShow = maxPagesToShow - leftPagesToShow - 1;
    let firstPageToShow = currentPage - leftPagesToShow;
    let lastPageToShow = currentPage + rightPagesToShow;

    if (firstPageToShow < 1) {
      lastPageToShow += Math.abs(firstPageToShow) + 1;
      firstPageToShow = 1;
    } else if (lastPageToShow > total) {
      firstPageToShow -= lastPageToShow - total;
      lastPageToShow = total;
    }

    if (firstPageToShow > 1) {
      paginationItems.push(renderPageItem(1));
      if (firstPageToShow > 2) {
        paginationItems.push(renderEllipsisItem());
      }
    }

    for (let i = firstPageToShow; i <= lastPageToShow; i++) {
      paginationItems.push(renderPageItem(i));
    }

    if (lastPageToShow < total) {
      if (lastPageToShow < total - 1) {
        paginationItems.push(renderEllipsisItem());
      }
      paginationItems.push(renderPageItem(total));
    }
  }

  const handlePublisher = (event) => {
    setPublisher(event.target.value);
  };

  const handleSearchChange = (event) => {
    localStorage.setItem("searchTerm", event.target.value);

    setSearchTerm(event.target.value);
  };

  const handleAuthorChange = (event) => {
    setSelectedAuthor(event.target.value);
  };

  const handleYearChange = (event) => {
    localStorage.setItem("filterYear", event.target.value);
    setSelectedYear(event.target.value);
  };

  const handleGenreChange = (event) => {
    localStorage.setItem("filterDenre", event.target.value);
    setSelectedGenre(event.target.value);
  };

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  const handleRatingChange = (event) => {
    localStorage.setItem("filterRating", event.target.value);
    setSelectedRating(event.target.value);
  };

  const handleLevelChange = (event) => {
    localStorage.setItem("filterLevel", event.target.value);
    setSelectedLevel(event.target.value);
  };

  const clearFilter = () => {
    localStorage.setItem("searchTerm", "");
    setSearchTerm("");
    localStorage.setItem("filterYear", "");
    setSelectedYear("");
    localStorage.setItem("filterDenre", "");
    setSelectedGenre("");
    localStorage.setItem("filterRating", "");
    setSelectedRating("");
    localStorage.setItem("filterLevel", "");
    setSelectedLevel("");
    localStorage.setItem("filterAuthor", "");
    setClear(!clear);
  };

  // const filteredBooks = data.filter((book) => {
  //     if (searchTerm !== '' && !book.title.toLowerCase().includes(searchTerm.toLowerCase())) {
  //         return false;
  //     }
  //     if (selectedAuthor !== '' && book.author !== selectedAuthor) {
  //         return false;
  //     }
  //     if (selectedYear !== '' && book?.publishAdt !== parseInt(selectedYear)) {
  //         return false;
  //     }
  //     if (selectedGenre !== '' && book.category !== selectedGenre) {
  //         return false;
  //     }
  //     if (selectedLanguage !== '' && book.language !== selectedLanguage) {
  //         return false;
  //     }
  //     if (selectedRating !== '' && book.rating < parseInt(selectedRating)) {
  //         return false;
  //     }
  //     return true;
  // });

  const authors = [];
  const years = [];
  const genres = [];
  const languages = [];
  const ratings = ["", 1, 2, 3, 4, 5];

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  useEffect(() => {
    document.title = "LMS | Popular_Books";
  }, []);

  const handleGridClick = () => {
    setIsGrid(true);
    const booksContainer = document.querySelector(".books-container");
    if (booksContainer) {
      booksContainer.classList.remove("col-10");
      booksContainer.classList.add("col-5");
    }
  };

  const handleListClick = () => {
    setIsGrid(false);
    const booksContainer = document.querySelector(".books-container");
    if (booksContainer) {
      booksContainer.classList.remove("col-5");
      booksContainer.classList.add("col-10");
    }
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            width: "100vw",
            height: "100vh",
            backgroundSize: "cover",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            className="pt-4 mt-4"
            style={{ width: "20vw" }}
            src="https://cdn.dribbble.com/users/337865/screenshots/3209990/book-loader_v1.4_transp_800x600.gif"
            alt=""
          />
        </div>
      ) : (
        <div className={`pt-2 mt-5 ${isNightMode ? "nightHome" : ""}`}>
          <div
            className="d-lg-flex justify-content-center gap-2 pt-5 engbookslistframe"
            style={{ width: "100vw" }}
          >
            {/* <div className="col-2" style={{ border: '1px solid red', height: '500px' }}></div> */}
            <div className="col-lg-8 col-12 left_home_template">
              <div className="relative col-lg-11 m-auto d-flex align-items-center justify-content-center mb-3">
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  loadOptions={promiseOptions}
                  value={selectedTitleOption}
                  onChange={setSelectedTitleOption}
                  placeholder="Search for a book ..."
                  styles={{
                    dropdownIndicator: (provided) => ({
                      ...provided,
                      // display: 'none',
                    }),
                    control: (provided) => ({
                      ...provided,
                      // width: '800px',
                    }),
                  }}
                  className="search-bar"
                  // getOptionLabel={(option) => option.label}
                  // getOptionValue={(option) => option.value}
                  formatOptionLabel={(option) => (
                    <Link
                      style={{ textDecoration: "none" }}
                      to={`/myanmar_books/${option?.id}`}
                    >
                      <div
                        className="d-flex align-items-top border-bottom"
                        style={{ height: "60px" }}
                      >
                        <img
                          className="me-3"
                          style={{ height: "100%" }}
                          src={`https://cbs-dev13.s3.ap-southeast-1.amazonaws.com/pdf/images/${option?.photo}`}
                          alt={option?.label}
                        />

                        <div className="col-6">
                          {option?.label.charAt(0).toUpperCase() +
                            option?.label.slice(1)}
                          <p style={{ color: "#83A8C3" }} className="m-0">
                            {" "}
                            by{" "}
                            {option?.author
                              ?.map((author) => {
                                const nameParts = author.name.split(" ");
                                const capitalizedParts = nameParts.map(
                                  (part) =>
                                    part.charAt(0).toUpperCase() + part.slice(1)
                                );
                                return capitalizedParts.join(" ");
                              })
                              .join(", ")}
                          </p>
                        </div>
                        <div className="flex-end col-3">
                          <ul className="unstyled-list list-inline m-0">
                            <Rating
                              emptySymbol={
                                <Star
                                  size={20}
                                  fill="#babfc7"
                                  stroke="#babfc7"
                                />
                              }
                              fullSymbol={
                                <Star
                                  size={20}
                                  fill="#FF9F43"
                                  stroke="#FF9F43"
                                />
                              }
                              fractions={2}
                              initialRating={option.rating}
                              // direction={isRtl ? 'rtl' : 'ltr'}
                              direction="ltr"
                            />
                          </ul>
                        </div>
                      </div>
                    </Link>
                  )}
                />
                {/* <button onClick={handleSearchFilter} className='d-flex no-border justify-content-center align-items-center' style={{ border: '0px', width: '50px', height: '40px' }}>
                                    <Search />
                                </button> */}
              </div>
              <div className="d-flex justify-content-between align-items-center pb-4">
                <h5 className="ms-4">{`Found ${foundresults} books in total`}</h5>
                <div className="me-5 pe-1 filterDataDeviceSize">
                  {/* <label htmlFor="sort-options">Sort by:</label> */}
                  <select
                    style={{ width: "180px" }}
                    id="sort-options"
                    value={selectedOption}
                    onChange={handleOptionChange}
                  >
                    <option style={{ height: "50px" }} value="createdAt">
                      Filter Data
                    </option>
                    <option style={{ height: "50px" }} value="z_to_a">
                      Title Descending
                    </option>
                    <option style={{ height: "50px" }} value="a_to_z">
                      Title Ascending
                    </option>
                    <option style={{ height: "50px" }} value="descending">
                      Year Descending
                    </option>
                    <option style={{ height: "50px" }} value="ascending">
                      Year Ascending
                    </option>
                  </select>
                  <Grid
                    style={{ color: isGrid && "#0156f4" }}
                    onClick={handleGridClick}
                    className="ms-2"
                  />
                  <List
                    style={{ color: !isGrid && "#0156f4" }}
                    onClick={handleListClick}
                    className="ms-2"
                  />
                  {/* <a class="view-type type-list" data-type="list"></a> */}
                  {/* <i class="fa-solid fa-list"></i> */}
                  {/* <a style={{ width: '50px', height: '50px' }} href="https://www.flaticon.com/free-icons/listing" title="listing icons"></a> */}
                </div>
              </div>
              <div className="d-md-flex flex-wrap p-1 justify-content-center gap-lg-5 py-lg-4">
                {mmBooks?.map((each) => (
                  <div
                    className={`books-container ${
                      isGrid ? "col-5" : "col-10 mt-3 p-2"
                    } mb-5 mb-lg-0 position-relative each_children_of_left_home_template`}
                    style={{
                      border: "1px solid #0156f4",
                      borderRadius: ".2rem",
                      boxShadow: "-9px 6px 16px -6px rgba(45,56,80,0.75)",
                      minHeight: "153.66px",
                    }}
                  >
                    <div className="p-1" style={{ marginLeft: "6.5rem" }}>
                      <h5
                        className="m-0"
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {each?.title}
                      </h5>
                      <p style={{ color: "#83A8C3" }} className="m-0">
                        {each?.publicationDate}, by{" "}
                        {each?.author?.length > 1
                          ? `${each?.author?.[0]?.name}, ...`
                          : each?.author?.[0]?.name}
                      </p>

                      {/* <p style={{ color: '#83A8C3' }} className="m-0">{each?.publicationDate?.split("T")[0]}, by  {each?.author ? each?.author.map(author => author.name).join(', ') : "Not known"}</p> */}
                      <ul className="unstyled-list list-inline m-0">
                        <Rating
                          emptySymbol={
                            <Star size={25} fill="#babfc7" stroke="#babfc7" />
                          }
                          fullSymbol={
                            <Star size={25} fill="#FF9F43" stroke="#FF9F43" />
                          }
                          fractions={2}
                          initialRating={4}
                          // direction={isRtl ? 'rtl' : 'ltr'}
                          direction="ltr"
                        />
                      </ul>
                      <p style={{ color: "#83A8C3" }} className="m-0">
                        {each?.description.length > 60
                          ? each?.description.slice(0, 60) + "..."
                          : each?.description}
                      </p>
                      {/* <p style={{ color: '#83A8C3' }} className="m-0">A Nobel Prize-winning physicist explains what happened at the very beginning of the...</p> */}
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        bottom: "15px",
                        left: "-15px",
                      }}
                    >
                      <a
                        href={`/popularAuthors/642bef69a558c19ce090f478/${each?._id}`}
                      >
                        <img
                          src={
                            `https://cbs-dev13.s3.ap-southeast-1.amazonaws.com/pdf/images/${each?.coverPhoto}` ||
                            "https://images.penguinrandomhouse.com/cover/9780446310789"
                          }
                          alt=""
                          style={{
                            borderRadius: ".2rem",
                            border: "1px solid #0156f4",
                            width: "118px",
                            height: "162px",
                          }}
                        />
                      </a>
                    </div>
                  </div>
                ))}
              </div>

              {/* pagination */}
              <div className="pt-lg-3">
                <Pagination className="justify-content-center">
                  <Pagination.First onClick={() => handlePageClick(1)} />
                  <Pagination.Prev
                    onClick={() =>
                      handlePageClick(Math.max(currentPage - 1, 1))
                    }
                  />
                  {paginationItems}
                  <Pagination.Next
                    onClick={() =>
                      handlePageClick(Math.min(currentPage + 1, total))
                    }
                  />
                  <Pagination.Last onClick={() => handlePageClick(total)} />
                </Pagination>
              </div>
              <div
                className="d-flex justify-content-between mb-2"
                style={{ width: "95%" }}
              >
                <h5>Books per page:</h5>
                <Select
                  value={{ value: perPage, label: `${perPage} per page` }}
                  onChange={handlePerPageChange}
                  options={options}
                  menuPlacement="top"
                  className={`${isNightMode && "text-black"}`}
                />
              </div>
            </div>
            <div
              className="col-lg-3 col-12 ps-4 ps-lg-0 py-2"
              style={{ height: "auto" }}
            >
              <div className="bookfilterfixedDiv">
                <h4>BOOK FILTER</h4>

                {/* <label className='pb-2'>
                                    Publisher: <br />
                                    <input style={{ width: '300px', padding: '.3rem .2rem', borderRadius: '5px', border: '1px solid gray' }} type="text" value={publisher} onChange={handlePublisher} />
                                </label><br /> */}
                {/* <label className='pb-2'>
                                    Search by title: <br />
                                    <input style={{ width: '300px', padding: '.3rem .2rem', borderRadius: '5px', border: '1px solid gray' }} type="text" value={searchTerm} onChange={handleSearchChange} />
                                </label> */}
                {/* <label className='pb-2'>
                                    Filter by author: <br />
                                    <select style={{ width: '300px', padding: '.4rem .2rem', borderRadius: '5px', border: '1px solid gray' }} value={selectedAuthor} onChange={handleAuthorChange}>
                                        <option value=''>All</option>
                                        {allAuthors.map((author) => (
                                            <option key={author} value={author?.name}>{author?.name}</option>
                                        ))}
                                    </select>
                                </label><br /> */}
                <label className="pb-2">
                  Filter by Category: <br />
                  <select
                    style={{
                      width: "300px",
                      padding: ".4rem .2rem",
                      borderRadius: "5px",
                      border: "1px solid gray",
                    }}
                    value={selectedGenre}
                    onChange={handleGenreChange}
                  >
                    <option value="">All</option>
                    {allCategories?.map((genre, index) => (
                      <option key={index} value={genre}>
                        {genre === ""
                          ? "All"
                          : genre.charAt(0).toUpperCase() + genre.slice(1)}
                      </option>
                    ))}
                  </select>
                </label>
                <br />
                <label className="pb-2" style={{ paddingRight: "20px" }}>
                  Filter by year: <br />
                  {/* <select style={{ width: '140px', padding: '.4rem .2rem', borderRadius: '5px', border: '1px solid gray' }} value={selectedYear} onChange={handleYearChange}>
                                        {years.map((year) => (
                                            <option key={year} value={year}>{year === '' ? 'All' : year}</option>
                                        ))}
                                    </select> */}
                  <input
                    style={{
                      width: "140px",
                      padding: ".3rem .2rem",
                      borderRadius: "5px",
                      border: "1px solid gray",
                    }}
                    type="text"
                    value={selectedYear}
                    onChange={handleYearChange}
                  />
                </label>
                <label className="pb-2">
                  Filter by rating: <br />
                  <select
                    style={{
                      width: "140px",
                      padding: ".4rem .2rem",
                      borderRadius: "5px",
                      border: "1px solid gray",
                    }}
                    value={selectedRating}
                    onChange={handleRatingChange}
                  >
                    {ratings.map((rating) => (
                      <option key={rating} value={rating}>
                        {rating === "" ? "All" : rating}
                      </option>
                    ))}
                  </select>
                </label>
                <label className="pb-2">
                  Filter by Level: <br />
                  <select
                    style={{
                      width: "300px",
                      padding: ".4rem .2rem",
                      borderRadius: "5px",
                      border: "1px solid gray",
                    }}
                    value={selectedLevel}
                    onChange={handleLevelChange}
                  >
                    <option value="">All</option>
                    <option key="Basic" value="basic">
                      Basic
                    </option>
                    <option key="Intermediate" value="intermediate">
                      Intermediate
                    </option>
                    <option key="Advance" value="advance">
                      Advance
                    </option>
                  </select>
                </label>
                <br />
                <button
                  className="rounded mt-3"
                  style={{ padding: ".3rem .8rem" }}
                  onClick={filtersApi}
                >
                  Search
                </button>
                <button
                  className="rounded mt-3 ms-3"
                  style={{ padding: ".3rem .8rem" }}
                  onClick={clearFilter}
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PopularAuthorsBooks;
